import { add } from 'bianco.events';
import { ESC_KEY } from 'util/dom/key-codes';

/**
 * A list of all the open overlays, tooltips, sidebars etc.
 * @type {Map}
 */
const openOverlays = new Map();

/**
 * Add an opened overlay to the queue
 * @param key – Any kind of js instance
 * @param closerFn – A function to allow closing the overlay
 * @returns {Map} - the overlays map
 */
export function subscribe(key, closerFn) {
    openOverlays.set(key, closerFn);
    return openOverlays;
}

/**
 * @param key – The instance used to register the overlay close function
 * @returns {boolean}
 */
export function unsubscribe(key) {
    const found = openOverlays.has(key);
    if (found) {
        openOverlays.delete(key);
    }
    return found;
}

/**
 * If the esc key is pressed, close the last overlay added to the list
 */
add(document, 'keyup', ({ keyCode }) => {
    if (keyCode === ESC_KEY && openOverlays.size) {
        const [, closerFn] = Array.from(openOverlays).pop();
        closerFn();
    }
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/overlay-tracker.js